import { PlayCircle } from "lucide-react"
import { FC } from "react"
import { classNames } from "../../utils"
import { LinkBtn } from "../buttons"

interface Props {
  onClick: () => void
  className?: string
}

const LearnHowItWorksLinkBtn: FC<Props> = ({ onClick, className }) => (
  <LinkBtn className={classNames("-my-1", className)} onClick={onClick}>
    <PlayCircle size={20} />
    <span className="ml-2">Learn how it works</span>
  </LinkBtn>
)

export default LearnHowItWorksLinkBtn
